class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.product_card_id = this.id.replace("product_card-", "");
    this.form = this.querySelector("form");
    this.mobile = this.getAttribute("mobile");
    this.images = this.querySelectorAll(".variant_images img");
    this.materialField = this.querySelector("#fc-material");
    this.variantPrice = this.querySelector("#variant-price");
    this.hover_wrapper = this.querySelector("div.relative.group");
    this.hover_trigger = this.querySelector(".group > div.aspect-1");
    this.is_mobile = window.matchMedia("(max-width: 768px)").matches;
    if (this.form) {
      this.form.addEventListener("change", this.changeSwatch.bind(this));
    }

    this.init();
  }

  init() {
    if (this.variantPrice) {
      let active = this.form.querySelector("input:checked");
      this.variantPrice.innerHTML = active.getAttribute("sv-price");
    }
  }

  changeSwatch() {
    let option_group = "option-" + this.product_card_id;
    this.materialField.innerHTML = this.form.elements[option_group].value;

    if (this.variantPrice) {
      let active = this.form.querySelector("input:checked");
      this.variantPrice.innerHTML = active.getAttribute("sv-price");
    }

    this.images.forEach((element) => {
      element.classList.add("hidden");
      if (
        element.getAttribute("attached-option") ==
        this.form.elements[option_group].value
      ) {
        element.classList.remove("hidden");
      }
    });

    this.hover_wrapper.classList.remove("group");
    this.hover_trigger.addEventListener(
      "mouseenter",
      function (event, hover) {
        this.hover_wrapper.classList.add("group");
      }.bind(this),
      { once: true }
    );
  }
}
customElements.define("product-card", ProductCard);
